import { WidgetEditor } from '@juvare/widget-ui/WidgetEditor';
import React from 'react';
import { FormConfigContext } from '../FormConfigContext';
import { defaultFormWidgets } from '../WidgetForm';
import { defaultGroupLabelProvider, defaultWidgetLabelProvider } from '../WidgetForm/Utils';
export function FormEditor(props) {
    var _a, _b;
    const context = React.useContext(FormConfigContext);
    const rootParams = React.useMemo(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        return ({
            showErrors: 'all',
            valueProviders: (_b = (_a = props.valueProviders) !== null && _a !== void 0 ? _a : context.valueProviders) !== null && _b !== void 0 ? _b : emptyValueProviders,
            subFormProviders: (_d = (_c = props.subFormProviders) !== null && _c !== void 0 ? _c : context.subFormProviders) !== null && _d !== void 0 ? _d : emptySubFormProviders,
            rules: (_f = (_e = props.rules) !== null && _e !== void 0 ? _e : context.rules) !== null && _f !== void 0 ? _f : emptyRules,
            globalWidgetConfig: (_h = (_g = props.globalWidgetConfig) !== null && _g !== void 0 ? _g : context.globalWidgetConfig) !== null && _h !== void 0 ? _h : emptyGlobalWidgetConfig,
            formParams: (_j = props.formParams) !== null && _j !== void 0 ? _j : context.formParams,
        });
    }, [
        props.valueProviders,
        props.subFormProviders,
        props.rules,
        props.globalWidgetConfig,
        props.formParams,
        context.valueProviders,
        context.subFormProviders,
        context.rules,
        context.globalWidgetConfig,
        context.formParams,
    ]);
    return (React.createElement(WidgetEditor, Object.assign({ rootParams: rootParams, widgets: (_b = (_a = props.widgets) !== null && _a !== void 0 ? _a : context.widgets) !== null && _b !== void 0 ? _b : defaultFormWidgets, groupLabelProvider: defaultGroupLabelProvider, widgetLabelProvider: defaultWidgetLabelProvider, toolbarButtons: props.toolbarButtons, formatConfigOnSave: true, maxUndoStackLength: 100, allowEditConfigJson: true }, props)));
}
const emptyValueProviders = [];
const emptySubFormProviders = [];
const emptyRules = [];
const emptyGlobalWidgetConfig = {};
